import React from "react";
import {
  Row,
  Col,
  Flex,
  Statistic,
  Table,
  Tag,
  Typography,
  Card,
  Space,
  Button,
  Grid, // <- added
} from "antd";
import { useNavigate } from "react-router-dom"; // <- added
import { HomeOutlined, CaretLeftOutlined } from "@ant-design/icons"; // <- added
const { Title, Text } = Typography;

// ── Component ──────────────────────────────────────────
const Dashboard = () => {
  const navigate = useNavigate(); // <- added
  const screens = Grid.useBreakpoint(); // <- added
  // screens.sm è true quando la viewport è >= sm; regola la logica come preferisci
  const cards = [
    {
      key: "1",
      title: "Preparazione delle consistenze",
      image: "/assets/consistenze.png",
      path: "/Categorie",
    },
    {
      key: "2",
      title: "Assunzione farmaci",
      image: "/assets/farmaci.png",
      path: "/assunzione-farmaci",
    },
    {
      key: "3",
      title: "Idratazione",
      image: "/assets/idratazione.png",
      path: "/acqua-facile",
    },
  ];

  return (
    <Space direction="vertical" size={24} style={{ width: "100%" }}>
      <div
        style={{
          background: "white",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg, #f9b27fff, #ff8c00)",
            height: "100px",
            maxHeight: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 20px rgba(255, 106, 0, 0.3)",
            position: "relative",
          }}
        >
          <Button
            type="text"
            onClick={() => navigate("/")}
            icon={<CaretLeftOutlined />}
            aria-label="Home"
            style={{
              position: "absolute",
              left: 16,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#fff",
              fontSize: 20,
            }}
          >
            Back
          </Button>
          <div style={{ alignItems: "center", justifyContent: "center" }}>
            <Title
              level={1}
              style={{
                color: "#fff",
                letterSpacing: "-0.4px",
              }}
            >
              Pappa Time!
            </Title>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "40px 16px",
            maxWidth: 1100,
            margin: "0 auto",
          }}
        >
          <div style={{ maxWidth: 760, width: "100%" }}>
            <Title level={2} style={{ marginBottom: 12, color: "#333" }}>
              Semplice guida per:
            </Title>
          </div>

          <Row
            gutter={[16, 16]}
            justify="center"
            style={{ width: "100%", marginTop: 32 }}
          >
            {cards.map((card) => (
              <Col key={card.key} xs={24} sm={12} md={8}>
                <div
                  role="button"
                  tabIndex={0}
                  onClick={() => navigate(card.path)}
                  onKeyPress={() => console.log(`Clicked ${card.title}`)}
                  style={{
                    width: "100%",
                    minHeight: 220,
                    borderRadius: 20,
                    overflow: "hidden",
                    position: "relative",
                    cursor: "pointer",
                    backgroundImage: `url(${card.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    boxShadow: "0 12px 30px rgba(0, 0, 0, 0.12)",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      padding: "16px",
                      background: "rgba(0, 0, 0, 0.45)",
                      color: "#fff",
                      textAlign: "center",
                      fontWeight: 700,
                      letterSpacing: "0.2px",
                    }}
                  >
                    {card.title}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </Space>
  );
};

export default Dashboard;
